import { render, staticRenderFns } from "./releaseCom.vue?vue&type=template&id=22e3de62&"
import script from "./releaseCom.vue?vue&type=script&lang=ts&"
export * from "./releaseCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports